<div
  #formRow
  class="form-group d-flex flex-column"
  [ngClass]="{ 'mb-0': noMarginBottom }"
  [ngStyle]="{ 'max-width.px': maxWidthPx }"
>
  <label *ngIf="label && label.length" class="d-flex justify-content-between">
    {{ label | translate }}
    <info-tooltip
      *ngIf="tooltipLabel && tooltipLabel.length > 0"
      [label]="tooltipLabel"
      [icon]="tooltipIcon"
    ></info-tooltip>
    <label class="float-right required" *ngIf="required"> ({{ 'required' | translate }}) </label>
  </label>
  <div class="input-group" style="width: -webkit-fill-available">
    <div class="input-group-prepend" *ngIf="icon && icon.length"></div>
    <select
      class="form-control"
      [class]="classesString"
      [ngModel]="model"
      *ngIf="inputDisabled && !bindToObject"
      [disabled]="isSelectDisabled"
      disabled
    >
      <option
        *ngFor="let opt of options; trackBy: trackByFn"
        value="{{ opt && opt[optionKey] !== undefined ? opt[optionKey] : opt }}"
      >
        {{ (opt && opt[optionKey] !== undefined ? opt[optionKey] : opt) | translate }}
      </option>
    </select>
    <select
      [ngClass]="{
        'is-invalid': requiredCssClass,
      }"
      class="form-control"
      [attr.required]="required"
      [class]="classesString"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      (keyup)="onInputKeyPress($event)"
      (change)="onInputValueChange($event)"
      (blur)="onChange($event)"
      *ngIf="!inputDisabled && !bindToObject"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [attr.data-cy]="dataCyAttribute"
      [disabled]="isSelectDisabled"
    >
      <option
        *ngFor="let opt of options; trackBy: trackByFn"
        value="{{ opt && opt[optionKey] !== undefined ? opt[optionKey] : opt }}"
      >
        {{ (opt && opt[optionKeyText] ? opt[optionKeyText] : opt) | translate }}
      </option>
    </select>
    <select
      class="form-control"
      [compareWith]="compareWithFn"
      *ngIf="bindToObject"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      (blur)="onChange($event)"
      [disabled]="isSelectDisabled"
      data-cy="select-bind-to-object"
    >
      <ng-container *ngFor="let opt of options">
        <option *ngIf="opt[optionKeyText] !== '---.purchaseOrder.address.create'" [ngValue]="opt">
          {{ (opt && opt[optionKeyText] ? opt[optionKeyText] : opt) | translate }}
        </option>
        <hr *ngIf="opt[optionKeyText] === '---.purchaseOrder.address.create'" />
        <option
          *ngIf="opt[optionKeyText] === '---.purchaseOrder.address.create'"
          [ngValue]="opt"
          style="color: #f0142f"
        >
          {{ 'purchaseOrder.create.address' | translate }}
        </option>
      </ng-container>
      <!--      <option *ngFor="let opt of options" [ngValue]="opt">-->
      <!--        {{ (opt && opt[optionKeyText] ? opt[optionKeyText] : opt) | translate }}-->
      <!--      </option>-->
    </select>
    <div class="input-group-btn" *ngIf="(btnLabel && btnLabel.length) || (btnIcon && btnIcon.length)">
      <btn [label]="btnLabel" [classes]="btnClasses" [icon]="btnIcon" (onEvent)="onBtnClick($event)"></btn>
    </div>
    <div
      *ngIf="requiredCssClass"
      [ngClass]="{ 'invalid-feedback': requiredCssClass }"
      style="color: #f0142f"
      data-cy="error_msg"
    >
      {{ errors | formError: formControlName | translate }}
    </div>
  </div>
  <span class="input-group-unit" *ngIf="appendUnitEU"> EU </span>
  <span class="input-group-unit" *ngIf="appendUnitUK"> UK </span>
  <span class="input-group-unit" *ngIf="appendUnitUS"> US </span>
  <span class="input-group-unit" *ngIf="appendUnitCm"> cm </span>
</div>
